import styled from 'styled-components'
import { HeaderText6 } from '../../components/HeaderText'
import { STYLES } from '../../static/style'

export const SchoolDetailsSectionTitle = styled(HeaderText6)`
  margin: 0;
  width: 100%;
  border-bottom: 1px solid #f3f3f3;
  padding: 0.5rem 1rem;
  ${({ primary }) =>
    primary &&
    `
    color: ${STYLES.PRIMARY_COLOR};
  `}
`

export const SchoolDetailsSectionSubTitle = styled.div`
  margin: 0.75rem 0 0.5rem 0;
  width: 100%;
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  font-size: ${STYLES.FONT_SIZE_MD};
`

export const SchoolDetailsSectionContent = styled.div`
  padding: 0.5rem 1rem;
  width: 100%;
`
